const NAMESPACE = "pcfilteredselect";

const KEYS = {
    selectElementPromptText: "selectElementPromptText"
};

const MESSAGES = {
    [KEYS.selectElementPromptText]: {
        value: "Please select...",
        comment: "Initial value for select elements before an item has been chosen"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
